<template>
  <div class="select-picker">
    <van-popup v-model="visible" position="bottom">
      <van-picker
        show-toolbar
        :title="title"
        :value-key="valueKey"
        :columns="columns"
        :default-index="defaultIndex"
        @cancel="cancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, Picker } from "vant";
export default {
  name: "SelectPicker",
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  props: {
    valueKey: {
      type: String,
      default: "text"
    },
    height: {
      type: String,
      default: "50%"
    },
    title: {
      type: String,
      default: ""
    },
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultValue: {
      type: [Number, String],
      default: ""
    },
    change: { type: Function }
  },
  data() {
    return {
      visible: false
    };
  },
  computed: {
    defaultIndex() {
      const index = this.columns.findIndex(p => p.id == this.defaultValue);
      return index > -1 ? index : 0;
    }
  },
  created: function() {
    // console.log(this.defaultValue, this.columns);
    this.columns.map(p => {
      // if (p.id) {
      //   p.Id = p.id;
      //   delete p.id;
      // }
      // if (p.text) {
      //   p.Text = p.text;
      //   delete p.text;
      // }
      // if (p.ItemId) {
      //   p.Id = p.ItemId;
      //   delete p.ItemId;
      // }
      // if (p.ItemText) {
      //   p.Text = p.ItemText;
      //   delete p.ItemText;
      // }
      if (p.itemText) {
        p.text = p.itemText;
        delete p.itemText;
      }
      if (p.itemId) {
        p.id = p.itemId;
        delete p.itemId;
      }
    });
    console.log(this.columns);
  },
  mounted() {
    this.visible = true;
  },

  methods: {
    onConfirm(data) {
      this.$emit("change", data);
      this.cancel();
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    }
  }
};
</script>

<style lang="less"></style>
